import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, App, Events } from 'ionic-angular';
import { CoLocationComponent } from '../../components/co-location/co-location';
import { ConfigProvider } from '../../providers/config/config';
import { LocationsProvider } from '../../providers/locations/locations';
import { AppState } from '../../config/state';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
/**
 * Generated class for the CoMapPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-co-map',
  templateUrl: 'co-map.html',
})
export class CoMapPage {
  location: any;
  allLocations: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public config: ConfigProvider, public app: App, public locationsProvider: LocationsProvider, private state : AppState, private events : Events, private timeout : TimeoutFunctionsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.location = this.navParams.get("data");
    this.locationsProvider.getLocations().then(location =>
      this.allLocations = location
    )
  }

  hideModal() {
    this.viewCtrl.dismiss().catch(err=>{});
  }

  goToLocation(location: any) {
    this.config.load(this.state.appId).then(cfg => {
      this.viewCtrl.dismiss().then(() => {
        this.app.getRootNav().push(CoLocationComponent, { location: location, showNavbar: true });
      }).catch(err=>{});
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/co-map/co-map.ts